import { isJsonCapableColumn } from './is-json-capable-column';

/**
 * PSTUDIO-1433: decide whether entering INLINE edit on a grid cell should
 * auto-open the Expanded Cell View panel. Driven by a MobX `reaction` on
 * `tableStore.editingColumnId` in `table.tsx` — that id is set ONLY by
 * `toggleCellInput` (a real in-grid text edit), never by focusing the panel's
 * own editor, so it is a clean "the user started editing a cell" signal.
 *
 * Product decision (Leo/Edan, PSTUDIO-1433): auto-open ONLY for JSON-capable
 * columns (richAssetContent / parameterInput / analyticsEvent), where the panel
 * hosts the JSON CodeEditor and the extra space is genuinely useful. Editing an
 * ordinary text cell (Message, …) must NOT pop the panel open.
 *
 * PSTUDIO-4784 exception in practice: `analyticsEvent` is still JSON-capable, so
 * this function answers true for it, but its cell is a select column and
 * `toggleCellInput` never sets `editingColumnId` for a select — the reaction that
 * calls this never fires for it. The panel opens for that column by Shift+Enter
 * or the toolbar toggle only.
 *
 * The `panelAlreadyOpen` guard keeps this idempotent: switching between two JSON
 * cells while the panel is open is a no-op, and a user who deliberately closed
 * the panel mid-edit is not fought by an auto-reopen (the reaction only fires on
 * an editingColumnId CHANGE, and this returns false while it stays open).
 */
export function shouldAutoOpenExpandedCellView(
  editingColumnId: string | undefined,
  panelAlreadyOpen: boolean
): boolean {
  if (panelAlreadyOpen) return false;
  return isJsonCapableColumn(editingColumnId);
}
